import styled from 'styled-components';

export const StyledWrapper = styled.div<{
  split: string;
}>`
  display: flex;
  flex-direction: row;

  > * {
    &:not(:first-child:last-child):not(:last-child) {
      margin-right: -1px;
    }

    ${({ split }) => split && split.split('/').map((width, index) => `
      &:nth-child(${index + 1}) {
        width: ${width};
      }
    `).join('\n')}
  }
`;
